module.exports = __webpack_public_path__ + "0686a84ae1f2b438ea3e0f413a595960.pdf";